import { FC } from 'react'

import { CategoryIcon } from '@mxenabled/mxui'

import { CategoryGuids } from '../../core/constants/Category'
import type { WeGotTheBeat } from '../interfaces'

export const BeatCategoryIcon: FC<WeGotTheBeat> = ({ beat }) => {
  const { primary_category_guid, category_guids } = beat
  const categoryGuid = primary_category_guid || category_guids?.[0] || CategoryGuids.UNCATEGORIZED

  return <CategoryIcon categoryGuid={categoryGuid} size={32} sx={{ minWidth: 32 }} />
}
